export class RiskComplianceDto {
  id?: string;
  bankAuthorizationRequired: boolean;
  isIssuerBank: boolean;
  issuerBank: string;
  regulatedProducts: boolean;

  constructor(d?: RiskComplianceDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
